import React, { useRef } from 'react';
import { Animated, View } from 'react-native';

const LoadingBar = ({
  isLoading,
}) => {
  const increaseBar = useRef(new Animated.Value(0)).current; // Initial value for width: 0

  React.useEffect(() => {
    if (isLoading) {
      Animated.loop(
        Animated.timing(
          increaseBar,
          {
            toValue: 1,
            duration: 50000,
          },
        ),
      ).start();
    } else {
      Animated.timing(
        increaseBar,
        {
          toValue: 1,
          duration: 1000,
        },
      ).start();
    }
  }, [increaseBar, isLoading]);

  return (
    <View style={{
      height: 15,
      backgroundColor: '#edf2f7',
      borderRadius: 8,
      boxShadow: 'inset 0 1px 4px 0 rgba(0, 0, 0, 0.04)',
      border: 'solid 1px #e2e8f0',
      overflow: 'hidden',
    }}
    >
      <Animated.View style={{
        backgroundColor: '#008cff',
        borderRadius: 8,
        width: '100%',
        height: '100%',
        transformOrigin: 'left center',
        transform: [
          {
            scaleX: increaseBar,
          },
        ],
      }}
      />
    </View>
  );
};

export default LoadingBar;
